// extracted by mini-css-extract-plugin
export default {"formWrapper":"exporter-consignee-form_formWrapper__AKHAd","actionBtnWrapper":"exporter-consignee-form_actionBtnWrapper__-Q7EH","nextBtn":"exporter-consignee-form_nextBtn__Mw9+-"};